import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';
import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.nav.sidebar');
import { OnInit } from '@angular/core';
import { HostListener } from '@angular/core';
import { Service } from 'src/libs/portal/season/service';

@Component({
 standalone: false,
 selector: 'wiz-component-nav-sidebar',
template: templateSource || '',
    styles: [``],
})
export class ComponentNavSidebarComponent implements OnInit {
    public menus: any[] = [];
    public openMenus: any = {};
    public currentLang: string = 'en';
    public isSuperadmin: boolean = false;
    public isAdmin: boolean = false;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        this.currentLang = this.service.lang?.get() || 'en';
        const session = this.service.auth.session || {};
        this.isSuperadmin = String(session.role || '').toLowerCase() === 'superadmin' || String(session.id || '') === 'admin';
        this.isAdmin = this.isSuperadmin || String(session.role || '').toLowerCase() === 'admin';
        await this.loadSidebarPolicy();
        this.menus = [
            { key: 'dashboard', label: 'menu.dashboard', icon: 'bx bx-home-circle', link: '/kiera' },
            {
                label: 'menu.network_discovery', icon: 'bx bx-transfer-alt', children: [
                    { key: 'subnets', label: 'menu.subnets', icon: 'bx bx-transfer-alt', link: '/kiera/subnets' },
                    { key: 'bmc_discovery', label: 'menu.bmc_discovery', icon: 'bx bx-radar', link: '/kiera/bmc-discovery' },
                ]
            },
            {
                label: 'menu.resource_management', icon: 'bx bx-cube', children: [
                    { key: 'rack_view', label: 'menu.rack_view', icon: 'bx bx-layout', link: '/kiera/resourcerack' },
                    { key: 'zones', label: 'Zone/Rack 관리', icon: 'bx bx-map-pin', link: '/kiera/zones' },
                    { key: 'bmc_credentials', label: 'BMC Credentials', icon: 'bx bx-key', link: '/kiera/bmc-credentials' },
                    { key: 'groups', label: 'menu.groups', icon: 'bx bx-cube', link: '/kiera/groups' },
                    { key: 'nodes', label: 'menu.nodes', icon: 'bx bx-server', link: '/kiera/nodes' },
                    { key: 'api_node_registration', label: 'menu.api_node_registration', icon: 'bx bx-link-alt', link: '/kiera/nodes/api-register', hidden: !this.isAdmin },
                    { key: 'chassis', label: 'Chassis 관리', icon: 'bx bx-cabinet', link: '/kiera/chassis' },
                    { key: 'clusters', label: 'menu.clusters', icon: 'bx bx-network-chart', link: '/kiera/clusters' },
                ]
            },
            {
                label: 'menu.provisioning', icon: 'bx bx-transfer', children: [
                    { key: 'provisioning_rack_view', label: 'Rack View', icon: 'bx bx-layout', link: '/kiera/provisioning-rack' },
                    { key: 'actions', label: 'menu.actions', icon: 'bx bx-card', link: '/kiera/actions' },
                    { key: 'cluster_deploy', label: 'menu.cluster_deploy', icon: 'bx bx-git-branch', link: '/kiera/cluster-deploy' },
                    { key: 'script_config', label: 'menu.script_config', icon: 'bx bx-code-block', link: '/kiera/scripts' },
                    { key: 'images', label: 'menu.images', icon: 'bx bx-archive', link: '/kiera/images' },
                    { key: 'diskless', label: 'menu.diskless', icon: 'bx bxs-hot', link: '/kiera/diskless' },
                    { key: 'pe', label: 'menu.pe', icon: 'bx bxs-package', link: '/kiera/pe' },
                ]
            },
            {
                label: 'menu.operations', icon: 'bx bx-wrench', children: [
                    { key: 'operations_rack_view', label: 'Rack View', icon: 'bx bx-layout', link: '/kiera/operations-rack' },
                    { key: 'ssh_access', label: 'menu.ssh_access', icon: 'bx bx-key', link: '/kiera/ssh-access' },
                    { key: 'cluster_users', label: 'menu.cluster_users', icon: 'bx bx-user-check', link: '/kiera/cluster-users' },
                    { key: 'job_management', label: 'menu.job_management', icon: 'bx bx-task', link: '/kiera/jobs' },
                    { key: 'service_logs', label: 'menu.service_logs', icon: 'bx bx-list-ul', link: '/kiera/logs' },
                    { key: 'inspect', label: 'menu.inspect', icon: 'bx bx-shield-quarter', link: '/kiera/inspect' },
                ]
            },
            {
                label: 'menu.integrations', icon: 'bx bx-network-chart', children: [
                    { key: 'zabbix', label: 'Zabbix', icon: 'bx bx-bar-chart-alt-2', link: '/kiera/zabbix' },
                    { key: 'lustre', label: 'Lustre', icon: 'bx bx-data', link: '/kiera/lustre' },
                    { key: 'juju', label: 'Juju', icon: 'bx bx-git-branch', link: '/kiera/juju' },
                ]
            },
            {
                label: 'menu.admin_support', icon: 'bx bx-help-circle', children: [
                    { key: 'members', label: 'menu.members', icon: 'bx bx-user-circle', link: '/members', hidden: !this.isSuperadmin },
                    { key: 'log_policy', label: 'menu.log_policy', icon: 'bx bx-time-five', link: '/kiera/log-policy', hidden: !this.isSuperadmin },
                    { key: 'management_settings', label: 'menu.management_settings', icon: 'bx bx-slider-alt', link: '/kiera/management-settings', hidden: !this.isSuperadmin },
                    { key: 'debug', label: 'menu.debug', icon: 'bx bx-bug', link: '/kiera/debug' },
                    { key: 'assistant', label: 'menu.assistant', icon: 'bx bx-bot', link: '/kiera/assistant' },
                    { key: 'help', label: 'menu.help', icon: 'bx bx-help-circle', link: '/kiera/help', external: true },
                ]
            },
        ];
        this.menus = this.menus
            .map((menu: any) => {
                if (!menu.children) {
                    return this.isMenuAllowed(menu.key) ? menu : null;
                }
                return {
                    ...menu,
                    children: (menu.children || []).filter((child: any) => !child.hidden && this.isMenuAllowed(child.key)),
                };
            })
            .filter((menu: any) => !menu.hidden && (!menu.children || menu.children.length > 0));
        await this.service.render();
    }

    public async loadSidebarPolicy(force: boolean = false) {
        await this.service.auth.loadPermissions(force);
    }

    public isMenuAllowed(key: string) {
        return this.service.auth.can(key, 'read');
    }

    @HostListener('window:sidebar-policy-updated')
    public async onSidebarPolicyUpdated() {
        await this.loadSidebarPolicy(true);
        await this.ngOnInit();
    }

    @HostListener('document:click')
    public clickout() {
        this.service.status.toggle('navbar', true);
    }

    public isActive(link: string) {
        if (link === '/kiera') return location.pathname === '/kiera' || location.pathname === '/kiera/';
        if (link === '/kiera/nodes' && location.pathname.indexOf('/kiera/nodes/api-register') === 0) return false;
        return location.pathname.indexOf(link) === 0;
    }

    public isGroupActive(menu: any) {
        if (!menu.children) return false;
        return menu.children.some((c: any) => this.isActive(c.link));
    }

    public async toggleMenu(label: string) {
        this.openMenus[label] = !this.openMenus[label];
        await this.service.render();
    }

    public isMenuOpen(menu: any) {
        if (this.isGroupActive(menu)) return true;
        return !!this.openMenus[menu.label];
    }

    public async switchLang(lang: string) {
        this.currentLang = lang;
        await this.service.lang.set(lang);
        await this.service.render();
    }

    public openSwagger(event?: Event) {
        event?.preventDefault();
        event?.stopPropagation();
        const swaggerTab = window.open('/kiera/swagger', '_blank', 'noopener,noreferrer');
        if (swaggerTab) {
            swaggerTab.opener = null;
        }
    }
}

export default ComponentNavSidebarComponent;
